
import React from 'react';
import useAppContext from '../context/useAppContext';

const Footer = () => {
	const { innerTexts } = useAppContext();

  const currentYear = new Date().getFullYear();

	return (
    <footer id="footer">
      <p>{currentYear} © {innerTexts.companyFooterText}</p>
    </footer>
  );
}
export default Footer